module.exports = __webpack_public_path__ + "img/image-14.7a17778c.jpg";